export default __webpack_public_path__ + "static/media/Jain.5c342a2d.png";